"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createParser = exports.createFormatter = exports.find = exports.parse = exports.format = exports.normalize = exports.unshift = exports.shift = exports.isURI = exports.QUATERNARY_DELIMITER = exports.TERTIARY_DELIMITER = exports.SECONDARY_DELIMITER = exports.DELIMITER = void 0;
exports.DELIMITER = ':';
exports.SECONDARY_DELIMITER = '/';
exports.TERTIARY_DELIMITER = '|';
exports.QUATERNARY_DELIMITER = '@';
var PATTERN_DELIMITER = /:/g;
var PATTERN_SECONDARY_DELIMITER = /\//g;
var PATTERN_TERTIARY_DELIMITER = /\|/g;
var PATTERN_QUATERNARY_DELIMITER = /@/g;
var PATTERN_ANY_DELIMITER = /[:/|@]/;
exports.isURI = function (originalID, options) {
    var pattern = (options === null || options === void 0 ? void 0 : options.delimiter) || PATTERN_ANY_DELIMITER;
    var id = (options === null || options === void 0 ? void 0 : options.signature) ? exports.find(originalID, options) : originalID;
    if (!id) {
        return false;
    }
    var delimiter = pattern instanceof RegExp ? (id.match(pattern) || [])[0] : pattern;
    return id.indexOf(delimiter) !== -1 && id.split(delimiter).length === 4;
};
exports.shift = function (uri) {
    return uri
        .replace(PATTERN_TERTIARY_DELIMITER, exports.QUATERNARY_DELIMITER)
        .replace(PATTERN_SECONDARY_DELIMITER, exports.TERTIARY_DELIMITER)
        .replace(PATTERN_DELIMITER, exports.SECONDARY_DELIMITER);
};
exports.unshift = function (uri) {
    return uri
        .replace(PATTERN_SECONDARY_DELIMITER, exports.DELIMITER)
        .replace(PATTERN_TERTIARY_DELIMITER, exports.SECONDARY_DELIMITER)
        .replace(PATTERN_QUATERNARY_DELIMITER, exports.TERTIARY_DELIMITER);
};
exports.normalize = function (uri) {
    var delimiter = (uri.match(PATTERN_ANY_DELIMITER) || [])[0];
    if (!delimiter)
        return uri;
    var nextURI = uri;
    while (delimiter !== exports.DELIMITER) {
        nextURI = exports.unshift(nextURI);
        delimiter = (nextURI.match(PATTERN_ANY_DELIMITER) || [])[0];
    }
    return nextURI;
};
exports.format = function (uri, options) {
    var _a = Array.isArray(uri)
        ? uri
        : [uri.type, uri.contextType, uri.context, uri.id], type = _a[0], contextType = _a[1], context = _a[2], id = _a[3];
    return [
        type,
        contextType,
        context && exports.isURI(context) ? exports.shift(context) : context,
        exports.isURI(id) ? exports.shift(id) : id
    ].join((options || {}).delimiter || exports.DELIMITER);
};
exports.parse = function (uri, options) {
    var pattern = (options === null || options === void 0 ? void 0 : options.delimiter) || PATTERN_ANY_DELIMITER;
    var signature = options === null || options === void 0 ? void 0 : options.signature;
    var delimiter = pattern instanceof RegExp ? (uri.match(pattern) || [])[0] : pattern;
    var _a = uri.split(delimiter), type = _a[0], contextType = _a[1], context = _a[2], id = _a[3];
    var components = {
        type: type,
        contextType: contextType,
        context: typeof context === 'string' && exports.isURI(context)
            ? exports.unshift(context)
            : context,
        id: id
    };
    if (!signature ||
        (components.type === signature.type &&
            components.contextType === signature.contextType)) {
        return components;
    }
    if (exports.isURI(components.context)) {
        return exports.parse(components.context, options);
    }
    throw new Error("Can not parse URI " + uri);
};
exports.find = function (uri, options) {
    try {
        return exports.format(exports.parse(uri, options));
    }
    catch (e) { }
};
var DEFAULT_TRANSFORM = function (v) { return v; };
function createFormatter(options) {
    var _a = options || {}, _b = _a.delimiter, delimiter = _b === void 0 ? exports.DELIMITER : _b, _c = _a.transform, transform = _c === void 0 ? DEFAULT_TRANSFORM : _c;
    return function (uri, options) {
        return exports.format(transform(uri), { delimiter: (options === null || options === void 0 ? void 0 : options.delimiter) || delimiter });
    };
}
exports.createFormatter = createFormatter;
function createParser(options) {
    var _a = options || {}, _b = _a.delimiter, delimiter = _b === void 0 ? PATTERN_ANY_DELIMITER : _b, signature = _a.signature, _c = _a.transform, transform = _c === void 0 ? DEFAULT_TRANSFORM : _c;
    return function (uri, options) {
        var components = exports.parse(uri, {
            delimiter: (options === null || options === void 0 ? void 0 : options.delimiter) || delimiter,
            signature: (options === null || options === void 0 ? void 0 : options.signature) || signature
        });
        return components ? transform(components) : undefined;
    };
}
exports.createParser = createParser;
//# sourceMappingURL=uri.js.map